// EyeTest.js
import React, { useState, useRef } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Tes Mata - Kalkulator Pemeriksaan dan Pengukuran Mata";
const DESCRIPTION = "Kalkulator melakukan pemeriksaan mata dengan sederhana dan jelas berdasarkan tes Snellen";
const KEYWORDS = "hitung lensa mata, hitung kekuatan optik";
const OG_URL = "https://do-calculate.com/calculator/id/eye-test/";
const lines = [
  {
    text: "E",
    size: "90px",
    value: "6/60",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "FP",
    size: "80px",
    value: "6/30",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "T O Z",
    size: "70px",
    value: "6/21",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "L P E D",
    size: "60px",
    value: "6/15",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "P E C F D",
    size: "50px",
    value: "6/12",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "E D F C Z P",
    size: "40px",
    value: "6/9",
    advice: "Anda harus berkonsultasi dengan dokter.",
    test: "bad",
  },
  {
    text: "F E L O P Z D",
    size: "30px",
    value: "6/7.5",
    advice: "Teruslah menjaga kesehatan mata Anda.",
    test: "good",
  },
  {
    text: "D E F P O T E C",
    size: "25px",
    value: "6/6",
    advice: "Teruslah menjaga kesehatan mata Anda.",
    test: "good",
  },
  {
    text: "L E F O D P C T",
    size: "20px",
    value: "6/6",
    advice: "Teruslah menjaga kesehatan mata Anda.",
    test: "good",
  },
  {
    text: "P E F C Z P T O",
    size: "15px",
    value: "6/6",
    advice: "Teruslah menjaga kesehatan mata Anda.",
    test: "good",
  },
];
function Calculator() {
  const [result, setResult] = useState(null);
  const resultRef = useRef(null);
  const handleRowClick = (line) => {
    setResult(line);
    console.log(line);
    console.log(result);
    if (resultRef.current) {
      resultRef.current.scrollIntoView();
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Aplikasi ini menyediakan tes sederhana untuk memeriksa ketajaman visual menggunakan perangkat seluler Anda. Serangkaian grafik visual yang berisi huruf dan angka dengan berbagai ukuran akan ditampilkan. Anda harus mengidentifikasi huruf atau angka yang dapat Anda lihat dengan jelas dari jarak yang ditentukan. Kemampuan Anda untuk melihat huruf dan angka kecil akan dinilai untuk menentukan ketajaman visual Anda.
                </p>
                <p>Cara melakukan tes:</p>
                <ul>
                  <li>
                    Ciptakan lingkungan yang nyaman: Pastikan Anda berada di area dengan pencahayaan yang baik dan gangguan minimal. Sesuaikan kecerahan perangkat Anda ke tingkat yang nyaman.
                  </li>
                  <li>
                    Jaga jarak yang tepat: Pegang perangkat Anda sekitar 4 kaki (1,2 meter) dari mata Anda.
                  </li>
                  <li>
                    Tutup satu mata pada satu waktu: Gunakan tangan Anda untuk menutup salah satu mata sepenuhnya saat melakukan tes pada mata lainnya.
                  </li>
                </ul>
                <p>Faktor-faktor yang mempengaruhi akurasi pemeriksaan:</p>
                <ul>
                  <li>
                    Ukuran dan kualitas layar: Ukuran dan kualitas layar dapat mempengaruhi akurasi tes.
                  </li>
                  <li>
                    Kondisi pencahayaan: Pencahayaan yang tidak memadai atau berlebihan dapat mempengaruhi kemampuan Anda untuk melihat grafik dengan jelas.
                  </li>
                  <li>
                    Faktor individu: Faktor-faktor seperti ketegangan mata, kelelahan, atau penyakit mata yang mendasarinya dapat mempengaruhi akurasi tes.
                  </li>
                </ul>
                <p>
                  <b>
                    <u>Catatan Penting:</u> Harap dicatat bahwa tes ini bukan pengganti pemeriksaan mata komprehensif oleh profesional kesehatan. Disarankan untuk berkonsultasi dengan dokter mata untuk evaluasi yang akurat dari kondisi penglihatan Anda. Tes ini dimaksudkan sebagai alat skrining awal. Jika Anda mengalami perubahan dalam penglihatan Anda, seperti penglihatan kabur, penglihatan ganda, atau kesulitan membaca, penting untuk mencari perawatan kesehatan profesional.
                  </b>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <div className="bg-warning text-black text-center p-3">
                  <p>
                    Silakan pilih baris yang tidak dapat Anda baca dengan jelas untuk menampilkan hasil
                  </p>
                </div>
                <hr />
                <div className="list-group">
                  {lines.map((line, index) => (
                    <div
                      key={index}
                      onClick={() => handleRowClick(line)}
                      className="list-group-item"
                      style={{
                        fontSize: line.size,
                        cursor: "pointer",
                        textAlign: "center",
                        border: "2px solid transparent",
                        borderRadius: "8px",
                        padding: "8px",
                        marginBottom: "10px",
                      }}
                    >
                      {line.text}
                    </div>
                  ))}
                </div>
                {result && (
                  <div
                    ref={resultRef}
                    className={`alert ${
                      result.test === "good" ? "alert-success" : "alert-warning"
                    } mt-4`}
                  >
                    <h4>Hasil: {result.value}</h4>
                    {result.advice && <p>{result.advice}</p>}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Apa itu Tes Snellen?</h2>{" "}
                  </u>
                  <p>
                    Tes Snellen adalah pemeriksaan ketajaman visual, yang mengukur kemampuan untuk melihat detail halus.
                  </p>
                  <p>
                    Tes ini terdiri dari beberapa baris yang berisi huruf dengan ukuran berbeda.
                  </p>
                  <p>Semakin baik Anda dapat membaca huruf kecil, semakin baik ketajaman penglihatan Anda.</p>
                  <div className="p-3 mb-2 bg-info  ">Contoh hasil 6/6</div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Cara Menafsirkan Hasil</h2>{" "}
                  </u>
                  <p>Ketajaman visual ditentukan oleh baris terkecil yang dapat dibaca seseorang.</p>
                  <ul>
                    <li>
                      20/20 berarti seseorang dapat membaca apa yang seharusnya dilihat oleh orang normal pada jarak 20 kaki.
                    </li>
                    <li>
                      20/40 berarti seseorang perlu mendekat hingga setengah jarak untuk melihat apa yang dapat dilihat oleh orang normal pada jarak 20 kaki.
                    </li>
                  </ul>
                  <p>
                    Semakin rendah rasio dari 20/20, semakin besar indikasi penglihatan yang buruk.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh hasil: 20/40
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>{" "}
                  </u>
                  <p>Bisakah ketajaman visual ditingkatkan?</p>
                  <ul>
                    <li>
                      Ya, melalui kacamata, lensa kontak, atau operasi.
                    </li>
                    <li>Apa arti hasil 6/60?</li>
                    <li>Berarti orang tersebut menderita penglihatan yang sangat buruk.</li>
                  </ul>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Hasil: 6/60
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;